/*=========================================================================================
  File Name: moduleBedType.js
  Description: BedTypes Module
  ----------------------------------------------------------------------------------------
  Item Name: JHM SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import state from "./moduleBedTypeState.js";
import mutations from "./moduleBedTypeMutations.js";
import actions from "./moduleBedTypeActions.js";
import getters from "./moduleBedTypeGetters.js";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
